import 'primereact/resources/primereact.css';
import React, {ReactNode} from 'react';
import './shared/translation/i18n';
import LoadingOverlay from "./shared/session/components/LoadingOverlay";
import {pdfjs} from 'react-pdf';
import {RTFJS} from "rtf.js";
import portalConfiguration from "./shared/configuration/PortalConfiguration";
import {withTranslation} from "react-i18next";
import Portal from "./portal/Portal";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Admin from "./admin/Admin";
import {PATH_SEPARATOR} from "./shared/helper/FileHelper";
import OAuth from "./oauth/OAuth";
import {Archive} from 'libarchive.js/main.js';
import ErrorHandler from "./ErrorHandler";
import {i18nInit} from "./shared/translation/i18n";
import PortalPureComponent from "./shared/components/PortalPureComponent";

const TranslatedPortal = withTranslation()(Portal);
const TranslatedAdministration = withTranslation()(Admin);
const TranslatedErrorHandler = withTranslation()(ErrorHandler);

/**
 * The state of an {@link App} component
 */
interface appStatus {
	loaded: boolean;
}

/**
 * This is the main application component and entrypoint for all routes
 */
export default class App extends PortalPureComponent<any, appStatus> {
	constructor(props: Readonly<any>) {
		super(props);

		this.state = {
			loaded: false
		}
	}

	/**
	 * This is called when the component is mounted
	 */
	public async componentDidMount(): Promise<void> {
		await super.componentDidMount();
		await portalConfiguration.init();

		if (portalConfiguration.production) {
			// block console output
			console.log = (...args) => {
			};
			console.debug = (...args) => {
			};
			console.warn = (...args) => {
			};
		}

		await i18nInit();

		let script: HTMLScriptElement = document.createElement("script");
		script.setAttribute("type", "application/javascript");
		script.src = process.env.PUBLIC_URL + "/js/tiff" + portalConfiguration.cachingPath + ".js";
		script.defer = true;
		document.head.append(script);

		script = document.createElement("script");
		script.setAttribute("type", "application/javascript");
		script.src = process.env.PUBLIC_URL + "/js/x509" + portalConfiguration.cachingPath + ".js";
		script.defer = true;
		document.head.append(script);

		let favicon: HTMLLinkElement = document.createElement("link");
		favicon.href = process.env.PUBLIC_URL + "/favicon" + portalConfiguration.cachingPath + ".ico"
		favicon.rel = "icon";
		favicon.type = "image/x-icon";
		document.head.append(favicon);

		pdfjs.GlobalWorkerOptions.workerSrc = "worker/pdf.worker" + portalConfiguration.cachingPath + ".js";

		Archive.init({
			workerUrl: "worker/worker-bundle" + portalConfiguration.cachingPath + ".js"
		});

		RTFJS.loggingEnabled(portalConfiguration.debug);

		this.setState({
			loaded: true
		});
	}

	/**
	 * render component as react node
	 */
	public render(): ReactNode {
		if (!this.state.loaded) {
			return <LoadingOverlay visible={true} language={"en"}/>;
		}

		let subpath: string = portalConfiguration.production ? portalConfiguration.baseUrl.pathname : PATH_SEPARATOR;

		return (
			<TranslatedErrorHandler>
				<BrowserRouter>
					<Routes>
						<Route path={subpath + Admin.route} element={<TranslatedAdministration/>}/>
						<Route path={subpath + Portal.route} element={<TranslatedPortal/>}/>
						<Route path={subpath + OAuth.route} element={<OAuth/>}/>
					</Routes>
				</BrowserRouter>
			</TranslatedErrorHandler>
		);
	}
}
